import {ExternalFavoriteTrackingLocation} from "../../../tracking/amplitude/get_amplitude_external_favorite_properties";

export interface IFavoritesOverlayState {
    isOpen: boolean;
}

export interface IFavoritesOverlayWithFavoriteIdState {
    favoriteId: number | null;
    isOpen: boolean;
    trackingLocation: ExternalFavoriteTrackingLocation;
}

export interface IOpenFavoriteOverlayPayload {
    favoriteId: number;
    trackingLocation?: ExternalFavoriteTrackingLocation;
}

export interface IFavoritesExternalOverlaysState {
    addOffer: IFavoritesOverlayState;
    addOfferLoading: IFavoritesOverlayState;
    addOfferSuccess: IFavoritesOverlayWithFavoriteIdState;
    editExternal: IFavoritesOverlayWithFavoriteIdState;
}

const createClosedFavoriteOverlayState = (): IFavoritesOverlayWithFavoriteIdState => ({
    favoriteId: null,
    isOpen: false,
    trackingLocation: ExternalFavoriteTrackingLocation.FAVOURITE
});

export const closedFavoritesExternalOverlaysState: IFavoritesExternalOverlaysState = {
    addOffer: {isOpen: false},
    addOfferLoading: {isOpen: false},
    addOfferSuccess: createClosedFavoriteOverlayState(),
    editExternal: createClosedFavoriteOverlayState()
};
import {ExternalFavoriteTrackingLocation} from "../../../tracking/amplitude/get_amplitude_external_favorite_properties";

export interface IFavoritesOverlayState {
    isOpen: boolean;
}

export interface IFavoritesOverlayWithFavoriteIdState {
    favoriteId: number | null;
    isOpen: boolean;
    trackingLocation: ExternalFavoriteTrackingLocation;
}

export interface IOpenFavoriteOverlayPayload {
    favoriteId: number;
    trackingLocation?: ExternalFavoriteTrackingLocation;
}

export interface IFavoritesExternalOverlaysState {
    addOffer: IFavoritesOverlayState;
    addOfferLoading: IFavoritesOverlayState;
    addOfferSuccess: IFavoritesOverlayWithFavoriteIdState;
    editExternal: IFavoritesOverlayWithFavoriteIdState;
}

const createClosedFavoriteOverlayState = (): IFavoritesOverlayWithFavoriteIdState => ({
    favoriteId: null,
    isOpen: false,
    trackingLocation: ExternalFavoriteTrackingLocation.FAVOURITE
});

export const closedFavoritesExternalOverlaysState: IFavoritesExternalOverlaysState = {
    addOffer: {isOpen: false},
    addOfferLoading: {isOpen: false},
    addOfferSuccess: createClosedFavoriteOverlayState(),
    editExternal: createClosedFavoriteOverlayState()
};
